import {request} from './request';

/**
 * 上传文件
 */
export const uploadFile = (file, onUploadProgress = () => {}) => {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/api/Upload/upload', formData, {
        onUploadProgress,
    });
};
// General 其他接口
export const GeneralService = {
    // 用户搜索历史
    getSearchHistory: (data) => request.get('/api/General/getSearchHistory', data),
    // 删除||清空搜索历史
    delSearchHistory: (data) => request.post('/api/General/delSearchHistory', data),
}

// Login 用户登录
export const LoginService = {
    // 用户统一登录
    unifiedLogin: (data) => request.post('/api/Login/unifiedLogin', data),
    // 获取验证码
    getCaptcha: (data) => request.post('/api/Login/getCaptcha', data),
}

// Expedite 不需要验证token接口
export const ExpediteService = {
    // 获取首页轮播图
    getBanner: (data) => request.get('/api/Expedite/getBanner', data),
    // 获取会员等级设置
    getUserLevelSet: (data) => request.get('/api/Expedite/getUserLevelSet', data),
    // 发送短信验证码
    sendSms: (data) => request.post('/api/Expedite/sendSms', data),
    // 发送邮箱验证码
    emailSms: (data) => request.post('/api/Expedite/emailSms', data),
    // 获取热搜设置
    getTopSearch: (data) => request.post('/api/Expedite/getTopSearch', data),
    // 获取签名
    getWeChatSign: (data) => request.post('/api/Expedite/getWeChatSign', data),
    // 获取平台文案设置
    getSysConfig: (data) => request.post('/api/Expedite/getSysConfig', data),
    // 获取客服设置
    getServiceSet: (data) => request.post('/api/Expedite/getServiceSet', data),
}

// LevelOrder 会员等级订单
export const LevelOrderService = {
    // 开通会员（续费）订单
    createOrder: (data) => request.post('/api/Level_order/createOrder', data),
    // 获取订单详情
    getOrderDetail: (data) => request.get('/api/Level_order/getOrderDetail', data),
    // 订单支付
    payOrder: (data) => request.post('/api/Level_order/payOrder', data),
}

// UserCenter 会员个人中心
export const UserCenterService = {
    // 获取个人信息
    getUserInfo: (data, notShowLoginWindow = false) => {
        return request.get('/api/User_center/getUserInfo', data, {notShowLoginWindow});
    },
    // 编辑个人信息
    updateUserInfo: (data) => request.post('/api/User_center/updateUserInfo', data),
    // 绑定手机号
    modifyPhone: (data) => request.post('/api/User_center/modifyPhone', data),
    // 更换或设置登录密码
    modifyPassword: (data) => request.post('/api/User_center/modifyPassword', data),
    // 完善用户openid
    saveOpenid: (data) => request.post('/api/User_center/saveOpenid', data),
}

// UserManage 会员管理
export const UserManageService = {
    // 用户反馈
    leaveFeedback: (data) => request.get('/api/User_manage/leaveFeedback', data),
}

// Video 视频
export const VideoService = {
    // 获取分类
    getCateTree: (data) => request.get('/api/Video/getCateTree', data),
    // 获取视频标签
    getVideoLabel: (data) => request.get('/api/Video/getVideoLabel', data),
    // 获取视频列表(平台发布)
    getVideoList: (data) => request.get('/api/Video/getVideoList', data),
    // 获取视频详情(平台)
    getVideoDetail: (data) => request.get('/api/Video/getVideoDetail', data),
    // 获取视频列表(用户发布【审核通过的】)
    getUserVideoList: (data) => request.get('/api/Video/getUserVideoList', data),
    // 获取我的视频列表
    getMyVideoList: (data) => request.get('/api/Video/getMyVideoList', data),
    // 获取视频详情(会员)
    getUserVideoDetail: (data) => request.get('/api/Video/getUserVideoDetail', data),
    // 用户提交或修改视频
    userReferVideo: (data) => request.post('/api/Video/userReferVideo', data),
    // 获取用户提交视频详情
    userReferVideoDetail: (data) => request.get('/api/Video/userReferVideoDetail', data),
    // 视频评论
    delUserVideo: (data) => request.post('/api/Video/delUserVideo', data),
    // 用户删除视频记录
    videoComment: (data) => request.post('/api/Video/videoComment', data),
    // 视频二级评论
    secondCommend: (data) => request.post('/api/Video/secondCommend', data),
    // 获取视频评论列表
    getVideoCommentList: (data) => request.get('/api/Video/getVideoCommentList', data),
    // 点赞||取消点赞
    videoTags: (data) => request.post('/api/Video/videoTags', data),
    // 视频转发（转发数量统计）
    videoTransmit: (data) => request.post('/api/Video/videoTransmit', data),
    // 视频播放（播放数量统计）
    videoPlay: (data) => request.post('/api/Video/videoPlay', data),
    // 删除评论
    delComment: (data) => request.post('/api/Video/delComment', data),
    // 获取推荐视频列表【不分页】
    getRecommendVideoList: (data) => request.get('/api/Video/getRecommendVideoList', data),
    // 视频搜索
    videoSearch: (data) => request.get('/api/Video/videoSearch', data),
}

// Report 举报
export const ReportService = {
    // 获取个人信息
    getReportCase: (data) => request.get('/api/Report/getReportCase', data),
    // 用户举报
    userReport: (data) => request.post('/api/Report/userReport', data),
}

// Collect 收藏
export const CollectService = {
    // 用户收藏（单个收藏）
    userCollect: (data) => request.post('/api/Collect/userCollect', data),
    // 获取用户收藏列表
    getUserCollectList: (data) => request.get('/api/Collect/getUserCollectList', data),
    // 取消收藏
    cancelCollect: (data) => request.post('/api/Collect/cancelCollect', data),
    // 取消收藏
    cancelCollectByType: (data) => request.post('/api/Collect/cancelCollectByType', data),
}

// Article 图文
export const ArticleService = {
    // 获取图文分类
    getArticleCate: (data) => request.get('/api/Article/getArticleCate', data),
    // 获取图文列表(平台发布)
    getArticleList: (data) => request.get('/api/Article/getArticleList', data),
    // 获取图文详情(平台)
    getArticleDetail: (data) => request.get('/api/Article/getArticleDetail', data),
    // 获取图文ITEM详情(平台)
    getArticleItemInfo: (data) => request.get('/api/Article/getArticleItemInfo', data),
    // 获取图文评论列表
    getArticleCommentList: (data) => request.get('/api/Article/getArticleCommentList', data),

    // 图文转发（转发数量统计）
    articleTransmit: (data) => request.post('/api/Article/articleTransmit', data),
    // 图文阅读（阅读数量统计）
    articleRead: (data) => request.post('/api/Article/articleRead', data),
    // 图文点赞||取消点赞
    articleTags: (data) => request.post('/api/Article/articleTags', data),
    // 图文评论
    articleComment: (data) => request.post('/api/Article/articleComment', data),
    // 图文二级评论
    secondCommend: (data) => request.post('/api/Article/secondCommend', data),
    // 评论点赞||取消点赞
    commentTags: (data) => request.post('/api/Article/commentTags', data),
    // 图文收藏||取消收藏
    articleCollect: (data) => request.post('/api/Article/articleCollect', data),

    // 用户提交或修改图文【个人】
    userReferArticle: (data) => request.post('/api/Article/userReferArticle', data),
    // 获取我的图文列表【个人】
    getMyArticleList: (data) => request.get('/api/Article/getMyArticleList', data),
    // 获取我的图文详情【个人】
    getUserArticleDetail: (data) => request.get('/api/Article/getUserArticleDetail', data),
    // 用户删除图文记录【个人】
    delUserArticle: (data) => request.post('/api/Article/delUserArticle', data),
}

// Datum 资料
export const DatumService = {
    // 获取资料目录
    getDatumCate: (data) => request.get('/api/Datum/getDatumCate', data),
    // 获取资料列表(平台发布)
    getDatumList: (data) => request.get('/api/Datum/getDatumList', data),
    // 获取资料详情(平台)
    getDatumDetail: (data) => request.get('/api/Datum/getDatumDetail', data),
    // 获取资料ITEM详情(平台)
    getDatumItemInfo: (data) => request.get('/api/Datum/getDatumItemInfo', data),
    // 资料转发（转发数量统计）
    datumTransmit: (data) => request.post('/api/Datum/datumTransmit', data),
    // 资料阅读（阅读数量统计）
    datumRead: (data) => request.post('/api/Datum/datumRead', data),
    // 资料收藏||取消收藏
    datumCollect: (data) => request.post('/api/Datum/datumCollect', data),
    // 资料点赞||取消点赞
    datumTags: (data) => request.post('/api/Datum/datumTags', data),
    // 用户提交或修改资料【个人】
    userReferDatum: (data) => request.post('/api/Datum/userReferDatum', data),
    // 获取我的资料列表【个人】
    getMyDatumList: (data) => request.get('/api/Datum/getMyDatumList', data),
    // 获取我的资料详情【个人】
    getUserDatumDetail: (data) => request.get('/api/Datum/getUserDatumDetail', data),
    // 用户删除资料记录【个人】
    delUserDatum: (data) => request.post('/api/Datum/delUserDatum', data),
}

// VideoDemand 阿里云视频点播
export const VideoDemandService = {
    // 获取视频播放凭证
    getVideoCredentials: (data) => request.post('/api/Video_demand/getVideoCredentials', data),
}

// Forum 论坛
export const ForumService = {
    // 获取论坛列表
    getForumList: (data) => request.post('/api/Forum/getForumList', data),
}
